// EMİR #91.2 — KIRIK-RESİM GLOBAL FALLBACK (son-çare, markalı placeholder).
//
// Görsel yüklenmeyince tarayıcının çirkin "yırtık resim" glifi + çıplak alt-metin
// çıkıyordu (avatar/story/post/kart küçük-resim) → "ucuz prototip" hissi. Bu modül
// capture-fazında TÜM img error'larını yakalar ve markalı nötr placeholder'a çevirir.
//
// 🔒 GÜVENLİK 1 — KİLİTLİ mlv3 poster/frame0 sistemi (PlayerCoreV3/FeedContainerV3)
// DOKUNULMAZ: `.mlv3-player`/`.mlv3-root`/`[data-mlv3-poster]` içi img'ler ATLANIR.
// 🔒 GÜVENLİK 2 — Mevcut bileşen onError'larını EZMEZ: swap bir sonraki tick'e
// ertelenir; bileşen kendi fallback'ini (src değiştirerek) uyguladıysa DOKUNULMAZ.
// Yalnız kimsenin ele almadığı GERÇEK son-çareye markalı placeholder konur.

// Nötr gradyan + soluk manzara-glifi (light+dark'ta kabul edilebilir; markasız-çirkin değil).
const PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120' preserveAspectRatio='xMidYMid slice'%3E%3Crect width='120' height='120' fill='%23e6e9ef'/%3E%3Ccircle cx='44' cy='44' r='9' fill='%23c4cad6'/%3E%3Cpath d='M26 84 L52 54 L68 70 L84 50 L98 84 Z' fill='%23c9cfda'/%3E%3C/svg%3E";

let installed = false;

export function installImageFallback(): void {
  if (installed || typeof document === "undefined") return;
  installed = true;
  document.addEventListener(
    "error",
    (e) => {
      const el = e.target as HTMLImageElement | null;
      if (!el || el.tagName !== "IMG") return;
      // Zaten işlendi.
      if ((el as any).dataset && el.dataset.imgFb === "1") return;
      // KİLİTLİ mlv3 poster/frame0 → dokunma.
      try {
        if (el.closest(".mlv3-player, .mlv3-root, [data-mlv3-poster], .mlv3-feed")) return;
      } catch (_) { /* closest yoksa devam */ }
      const originalSrc = el.currentSrc || el.src;
      // Bileşenin kendi onError'ına öncelik ver: bir sonraki tick'te yeniden değerlendir.
      setTimeout(() => {
        try {
          if (el.dataset.imgFb === "1") return;
          // Bileşen kendi fallback'ini uyguladı (src değişti) → DOKUNMA.
          if ((el.currentSrc || el.src) !== originalSrc) return;
          // Görsel bu arada düzeldiyse → dokunma.
          if (el.complete && el.naturalWidth > 0) return;
          el.dataset.imgFb = "1";
          el.src = PLACEHOLDER;
        } catch (_) { /* no-op */ }
      }, 0);
    },
    true, // capture: img error bubble etmez; global yakalama için şart.
  );
}

export default installImageFallback;
